import { render, staticRenderFns } from "./ListReports.vue?vue&type=template&id=3035696e&scoped=true"
import script from "./ListReports.vue?vue&type=script&lang=js"
export * from "./ListReports.vue?vue&type=script&lang=js"
import style0 from "./ListReports.vue?vue&type=style&index=0&id=3035696e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035696e",
  null
  
)

export default component.exports